import React from 'react';
import { clsx } from 'clsx';

type Props = {
	children: React.ReactNode;
	className?: string;
	id?: string;
};

export const Box = ({ children, className, id }: Props) => {
	const generateIdentifier = React.useId();
	const identifier = id ?? generateIdentifier;
	return (
		<div className={clsx(className)} data-testid="box-element" id={identifier}>
			{children}
		</div>
	);
};
Box.displayName = 'Box';
